import * as React from "react";
const SvgDownload = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.333 5.646H9.525V0H3.808v5.646H0l6.667 6.587ZM0 14.117V16h13.333v-1.883Z" }));
export default SvgDownload;
